import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black py-10">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <p className="font-playfair text-xl tracking-widest text-white/90 mb-6">
          OLIVIA FLEMMING
        </p>
        <a href="mailto:hello@oliviaflemming.co.uk" className="block text-white/60 hover:text-primary text-sm mb-4 transition-colors">
          hello@oliviaflemming.co.uk
        </a>
        <Link to="/journal" className="inline-block text-white/45 hover:text-gold text-xs tracking-[0.25em] uppercase mb-4 transition-colors">
          Journal
        </Link>
        <p className="text-white/30 text-sm">
          © {new Date().getFullYear()} Olivia Flemming. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
